/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { IFilterDetails } from "./ContentViewObserverContracts";

export const enum ContentViewObserverActionTypes {
    InitializeSelectedPivot = "ContentViewObserver/InitializeSelectedPivot",
    InitializeFilterState = "ContentViewObserver/InitializeFilterState",
    FilterStateChanged = "ContentViewObserver/FilterStateChanged",
    SelectedPivotChanged = "ContentViewObserver/SelectedPivotChanged",
    FilterToggled = "ContentViewObserver/FilterToggled"
}

export const ContentViewObserverActions = {
    initializeSelectedPivot: (selectedPivot: string) => createAction(ContentViewObserverActionTypes.InitializeSelectedPivot, { selectedPivot }),
    initializeFilterState: (filterDetails: IFilterDetails) => createAction(ContentViewObserverActionTypes.InitializeFilterState, { filterDetails }),
    /** Fired when the filter state changes */
    filterStateChanged: (filterState: IFilterState) => createAction(ContentViewObserverActionTypes.FilterStateChanged, filterState),
    selectedPivotChanged: (pivot: string) => createAction(ContentViewObserverActionTypes.SelectedPivotChanged, pivot),
    filterToggled: (visible: boolean) => createAction(ContentViewObserverActionTypes.FilterToggled, visible)
};

export type ContentViewObserverActions = ActionsUnion<typeof ContentViewObserverActions>;
